export { useDevPoll as useAdminPoll, type DevPoll as AdminPoll } from '../../components/gameweekGrid/devTools/useDevPoll'

/**
 * The backoffice's read-polling hook.
 *
 * Deliberately a re-export rather than a second implementation: `useDevPoll`
 * already solves exactly this problem — read on open, poll on an interval, stop on close, and
 * guard a response that lands after the panel closed — and it is tested. Two copies of a polling
 * hook is how one of them quietly stops clearing its interval.
 *
 * Renamed on the way through because *"dev poll"* is the wrong noun here: these panels are an
 * operator surface, not a dev tool, and one of them runs against real football.
 */
